module.exports = __webpack_public_path__ + "img/vi.eeff869c.jpg";